module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "cities"
  }, [_c('div', {
    staticClass: "centered city-addition"
  }, [_c('draggable', {
    attrs: {
      "options": {
        disabled: _vm.editableOffice !== null
      }
    },
    model: {
      value: (_vm.agenciesObject),
      callback: function($$v) {
        _vm.agenciesObject = $$v
      },
      expression: "agenciesObject"
    }
  }, _vm._l((_vm.agenciesObject), function(agency) {
    return _c('span', {
      staticClass: "city-wrapper",
      on: {
        "click": _vm.handleGetAgency
      }
    }, [(_vm.editableOffice !== agency.id) ? _c('router-link', {
      staticClass: "city-title",
      class: _vm.$route.params.id === agency.id || !_vm.$route.params.id && _vm.agencies[0].id === agency.id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'Office',
          params: {
            id: agency.id
          }
        }
      }
    }, [_vm._v(_vm._s(agency.city) + " ")]) : _c('span', {
      staticClass: "edit-city-wrapper"
    }, [_c('a', {
      staticClass: "delete hide-edit-city",
      on: {
        "click": function($event) {
          return _vm.toggleEditOffice(agency.id)
        }
      }
    }), _vm._v(" "), _c('b-input', {
      staticClass: "edit-city-input",
      model: {
        value: (_vm.newAgencyCity),
        callback: function($$v) {
          _vm.newAgencyCity = $$v
        },
        expression: "newAgencyCity"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "apply-icon is-medium",
      attrs: {
        "src": "/static/img/icons/apply.svg"
      },
      on: {
        "click": _vm.handleUpdateOffices
      }
    })], 1), _vm._v(" "), _c('img', {
      staticClass: "edit-icon",
      attrs: {
        "src": "/static/img/icons/edit.svg"
      },
      on: {
        "click": function($event) {
          return _vm.toggleEditOffice(agency.id)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.cityAdditionVisible) ? _c('span', {
    staticClass: "button-wrapper city-addition-wrapper",
    on: {
      "click": _vm.toggleCityAddition
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить город\n      ")]) : _vm._e(), _vm._v(" "), (_vm.cityAdditionVisible) ? _c('b-field', {
    staticClass: "city-addition-input"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название города"
    },
    model: {
      value: (_vm.cityName),
      callback: function($$v) {
        _vm.cityName = $$v
      },
      expression: "cityName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-primary button",
    on: {
      "click": _vm.handleAddCity
    }
  }, [_vm._v("Добавить")]), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-warning button",
    on: {
      "click": _vm.toggleCityAddition
    }
  }, [_vm._v("Отмена")])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.agencyObject) ? _c('div', {
    staticClass: "agency-information"
  }, [(_vm.agencyObject.announcement) ? _c('div', {
    staticClass: "announcement"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.toggleAnnouncement
    }
  }), _vm._v(" "), _c('b-field', {
    staticClass: "title"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок объявления"
    },
    model: {
      value: (_vm.agencyObject.announcement.title),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.announcement, "title", $$v)
      },
      expression: "agencyObject.announcement.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст объявления"
    },
    model: {
      value: (_vm.agencyObject.announcement.description),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.announcement, "description", $$v)
      },
      expression: "agencyObject.announcement.description"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Период размещения объявления на сайте")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "c"
    },
    on: {
      "change": _vm.announcementDataChanged
    },
    model: {
      value: (_vm.announcement.startDate),
      callback: function($$v) {
        _vm.$set(_vm.announcement, "startDate", $$v)
      },
      expression: "announcement.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "по"
    },
    on: {
      "change": _vm.announcementDataChanged
    },
    model: {
      value: (_vm.announcement.endDate),
      callback: function($$v) {
        _vm.$set(_vm.announcement, "endDate", $$v)
      },
      expression: "announcement.endDate"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns contacts"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('span', {
    staticClass: "has-text-centered agency-photo-title"
  }, [_vm._v("Иконка (отображается на главной)")]), _vm._v(" "), _c('div', {
    staticClass: "rounded-photo-wrapper agency-photo centered",
    style: (_vm.photoContainerStyle)
  }, [(!_vm.agencyObject.photo) ? _c('div', {
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('span', [_vm._v("Загрузить фото представительства")])]) : _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.deletePhoto
    }
  })]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(!_vm.agencyObject.announcement) ? _c('span', {
    staticClass: "button-wrapper is-marginless",
    on: {
      "click": _vm.toggleAnnouncement
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить объявление о празднике и время работы\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "time-title"
  }, [_vm._v("Время работы")]), _vm._v(" "), _c('p', {
    staticClass: "time-desription"
  }, [_vm._v("незаполненные поля считаются за выходной день и не отображаются на сайте")]), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("ПН")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.monStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "monStart", $$v)
      },
      expression: "agencyObject.schedule.monStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.monEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "monEnd", $$v)
      },
      expression: "agencyObject.schedule.monEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("ВТ")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.tueStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "tueStart", $$v)
      },
      expression: "agencyObject.schedule.tueStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.tueEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "tueEnd", $$v)
      },
      expression: "agencyObject.schedule.tueEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("СР")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.wedStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "wedStart", $$v)
      },
      expression: "agencyObject.schedule.wedStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.wedEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "wedEnd", $$v)
      },
      expression: "agencyObject.schedule.wedEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("ЧТ")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.thuStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "thuStart", $$v)
      },
      expression: "agencyObject.schedule.thuStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.thuEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "thuEnd", $$v)
      },
      expression: "agencyObject.schedule.thuEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("ПТ")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.friStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "friStart", $$v)
      },
      expression: "agencyObject.schedule.friStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.friEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "friEnd", $$v)
      },
      expression: "agencyObject.schedule.friEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("СБ")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.satStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "satStart", $$v)
      },
      expression: "agencyObject.schedule.satStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.satEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "satEnd", $$v)
      },
      expression: "agencyObject.schedule.satEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day centered"
  }, [_c('span', {
    staticClass: "day-title"
  }, [_vm._v("ВС")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.sunStart),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "sunStart", $$v)
      },
      expression: "agencyObject.schedule.sunStart"
    }
  }), _vm._v("\n            —\n            "), _c('b-input', {
    attrs: {
      "placeholder": "00:00"
    },
    model: {
      value: (_vm.agencyObject.schedule.sunEnd),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject.schedule, "sunEnd", $$v)
      },
      expression: "agencyObject.schedule.sunEnd"
    }
  })], 1)]), _vm._v(" "), _c('b-field', {
    staticClass: "agency-address",
    attrs: {
      "label": "адрес представительства"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "адрес"
    },
    on: {
      "blur": function($event) {
        return _vm.getAddress()
      }
    },
    model: {
      value: (_vm.agencyObject.address),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject, "address", $$v)
      },
      expression: "agencyObject.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": "email представительства"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "email"
    },
    model: {
      value: (_vm.agencyObject.email),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject, "email", $$v)
      },
      expression: "agencyObject.email"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "телефон представительства "
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "телефон"
    },
    model: {
      value: (_vm.agencyObject.phone),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject, "phone", $$v)
      },
      expression: "agencyObject.phone"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "почтовый индекс"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "индекс"
    },
    model: {
      value: (_vm.agencyObject.index),
      callback: function($$v) {
        _vm.$set(_vm.agencyObject, "index", $$v)
      },
      expression: "agencyObject.index"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Укажите адрес на карте")]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15,
      "options": {
        scrollwheel: false
      }
    },
    on: {
      "click": _vm.selectAddress
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "button delete-pin",
    on: {
      "click": _vm.deletePin
    }
  }, [_vm._v("Удалить метку")])])], 1), _vm._v(" "), _c('h2', [_vm._v("Консультанты")]), _vm._v(" "), _c('div', {
    staticClass: "consultants columns is-multiline"
  }, _vm._l((_vm.agencyObject.consultants), function(consultant) {
    return (consultant.type === 'common') ? _c('Consultant', {
      key: consultant.id,
      attrs: {
        "consultant": consultant
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.createCommonConsultant
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить специалиста\n      ")])]), _vm._v(" "), _c('h2', [_vm._v("Клиентский отдел")]), _vm._v(" "), _c('div', {
    staticClass: "consultants columns is-multiline"
  }, _vm._l((_vm.agencyObject.consultants), function(consultant) {
    return (consultant.type === 'client') ? _c('Consultant', {
      key: consultant.id,
      attrs: {
        "consultant": consultant
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.createClientConsultant
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить специалиста\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveAgency()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), _c('div', {
    staticClass: "delete-agency has-text-centered",
    on: {
      "click": function($event) {
        return _vm.deleteAgency(_vm.agencyObject.id)
      }
    }
  }, [_vm._v("Удалить представительство")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2497ca12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/Contacts.vue
// module id = 912
// module chunks = 0